var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGrayPin = function SvgGrayPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 48,
    viewBox: "0 0 35 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.709 44.742-.42.395-.716-.696c-2.507-2.437-5.934-5.769-8.876-9.906C4.41 29.912 1.828 24.413 1.828 18.23c0-8.661 6.686-15.96 15.497-15.96 8.79 0 15.477 7.298 15.477 15.96 0 12.332-9.255 21.027-15.093 26.512Z",
    fill: "#DC4405",
    stroke: "#D53E00",
    strokeWidth: 3
  })));
};
export default SvgGrayPin;